import { WorkflowCompletion } from '../workflowCompletion';

export const InnerWorkflowModal = ({
  open,
  setOpen,
  newActiveWorkflow,
  refetch,
  updateParent,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  newActiveWorkflow: any;
  refetch?: () => any;
  updateParent?: (activeCompletion?: any) => any;
}) =>
  newActiveWorkflow ? (
    <WorkflowCompletion
      workflowCompletion={newActiveWorkflow}
      open={open}
      onClose={() => {
        setOpen(false);
        if (refetch) {
          refetch();
        }
      }}
      isInnerWorkflow
      updateParent={updateParent}
    />
  ) : null;
